import { useEffect } from "react";
import Lenis from "lenis";
import { HashRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Samples } from "@/components/Samples";
import { Journal } from "@/components/Journal";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { EssayPage } from "@/components/EssayPage";
import { lenisRef } from "@/lib/smoothScroll";

const Home = () => (
  <>
    <Seo
      title="Melinda Adams — Copywriter & Content Writer"
      siteName="Melinda Adams"
      description="Melinda Adams translates product value into clear, distinctive customer language — website copy, SEO editorial, lifecycle email, UX writing, and campaigns."
      image="/melinda-portrait.webp"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "Person",
        name: "Melinda Adams",
        jobTitle: "Copywriter & Content Writer",
        email: "leeadamscompanyusa@zohomail.com",
        knowsAbout: ["Copywriting", "Content Writing", "SEO Editorial", "Lifecycle Email", "UX Writing"],
      }}
    />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <Samples />
      <Journal />
      <Services />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <HashRouter>
      <div className="bg-paper text-ink font-sans overflow-x-clip">
        <div className="grain-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/journal/:slug" element={<EssayPage />} />
        </Routes>
        <Toaster position="bottom-right" />
      </div>
    </HashRouter>
  );
}

export default App;
